import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
Vue.use(Vuex);
import {apiDomain,getHeader} from "./config/config";
import createPersistedState from 'vuex-persistedstate'

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    shops:[],
    users:[],
    products:[],
    detailProducts:[],
    deliveryFormObject:{},
    kusokFormObject:{},
    loginedUser: JSON.parse(window.localStorage.getItem('loginedUser')),
    wareHouses:[],
    wareHouseProducts:[],

    productCats:[],
    productMeasures:[],
    productColors:[],
    workPricesm:[],
    listWorkPrices:[],

    // In-app notification feed (bell-icon dropdown + /notifications page).
    // Hydrated by polling /api/notifications. Persisted across reloads
    // by vuex-persistedstate so the badge doesn't briefly drop to 0.
    notifications: [],
    notificationsUnread: 0,
    notificationsLastSeenId: 0,
    notificationsPollerId: null,
  },
  
  getters: {
    
    getDeliveryFormObject(state){
      return state.deliveryObject;
    },
    
    getWareHouseProductBalance(state){
      // alert(wareHouseId + " " +productId);
      return (wareHouseId,productId)=>{
        for (let i = 0;i<state.wareHouseProducts.length;i++){
          let obj = state.wareHouseProducts[i];
          if(obj.wareHouseId===wareHouseId && obj.productId===productId){
            //alert(JSON.stringify(obj));
            
            return obj.future ? obj.future : obj.productCount;
          }
        }
        return 0;
      }
    }
  
  },
  mutations: {
    
    SET_KUSOK_FORM_OBJECT(state,reqData){
      axios.post(apiDomain+'/admin/order/newpvhkusok',reqData,{headers:getHeader()})
      .then(response => {
        //alert(JSON.stringify(response.data));
        state.kusokFormObject=response.data;  
      }).catch(()=>{
          //console.log(error);
      }) 
    },
    SET_DELIVERY_FORM_OBJECT(state,reqData){
      axios.post(apiDomain+'/admin/order/neworder',reqData,{headers:getHeader()})
      .then(response => {
        //alert(JSON.stringify(response.data));
        state.deliveryFormObject=response.data;
      }).catch(()=>{
          //console.log(error);
      }) 
    },
    SET_DELIVERY_REFS(state,refType){
      if(refType==10){
        axios.get(apiDomain+'/admin/delivery/getfuturecount',{headers:getHeader()})
          .then(response=>{state.wareHouseProducts=response.data;});
      }
      else{
        axios.get(apiDomain+'/admin/delivery/refs/'+refType,{headers:getHeader()})
          .then(response=>{
              if(refType==1){
                  state.shops=response.data;
              }
              if(refType==2){
                  state.users=response.data;
              }
              if(refType==4){
                state.products=response.data;
              }
              if(refType==8){
                state.detailProducts=response.data;
              }
              if(refType==9){
                //alert(JSON.stringify(response.data));
                state.wareHouses=response.data;
              }
              
              if(refType==7){
                state.productCats=response.data;
              }
              if(refType==11){
                  state.productColors=response.data;
              }
              if(refType==12){
                  state.productMeasures=response.data;
              }
              if(refType==13){
                  state.workPrices=response.data;
              }
              if(refType==14){
                  state.listWorkPrices=response.data;
              }
          })
          .catch(() => {
              //console.log(error.message)
              
          }) 
      }
      
    },
    SET_LOGINED_USER(state){
      //alert("yess");
      state.loginedUser=JSON.parse(window.localStorage.getItem('loginedUser'));
    },
    LOG_OUT_SYSTEM(state){
      //alert("yess");
      state.loginedUser={}
      // Drop notification state on logout so a different user logging
      // in on the same machine doesn't see the previous one's bell.
      state.notifications = []
      state.notificationsUnread = 0
      state.notificationsLastSeenId = 0
      if (state.notificationsPollerId) {
        clearInterval(state.notificationsPollerId)
        state.notificationsPollerId = null
      }
    },
    SET_NOTIFICATIONS(state, list) { state.notifications = Array.isArray(list) ? list : [] },
    PREPEND_NOTIFICATIONS(state, list) {
      if (!Array.isArray(list) || !list.length) return
      // Drop duplicates by id (polling overlap), keep newest-first order.
      const existing = new Set(state.notifications.map(n => n.id))
      const fresh = list.filter(n => !existing.has(n.id))
      state.notifications = [...fresh, ...state.notifications]
    },
    APPEND_NOTIFICATIONS(state, list) {
      if (!Array.isArray(list) || !list.length) return
      const existing = new Set(state.notifications.map(n => n.id))
      const more = list.filter(n => !existing.has(n.id))
      state.notifications = [...state.notifications, ...more]
    },
    SET_NOTIFICATIONS_UNREAD(state, n) { state.notificationsUnread = Number(n) || 0 },
    MARK_NOTIFICATION_READ(state, id) {
      const item = state.notifications.find(n => n.id === id)
      if (item && !item.isRead) {
        item.isRead = true
        item.readAt = new Date().toISOString()
        state.notificationsUnread = Math.max(0, state.notificationsUnread - 1)
      }
    },
    MARK_ALL_NOTIFICATIONS_READ(state) {
      const now = new Date().toISOString()
      state.notifications = state.notifications.map(n =>
        n.isRead ? n : { ...n, isRead: true, readAt: now }
      )
      state.notificationsUnread = 0
    },
    SET_NOTIFICATIONS_LAST_SEEN(state, id) { state.notificationsLastSeenId = Number(id) || 0 },
    SET_NOTIFICATIONS_POLLER_ID(state, id) { state.notificationsPollerId = id },
  },
  actions: {
    setDeliveryRefs:(context,refType)=>{
      //alert("ref type "+refType);
      context.commit("SET_DELIVERY_REFS",refType);
    },
    
    setDeliveryFormObject:(context,reqData)=>{
      context.commit("SET_DELIVERY_FORM_OBJECT",reqData);
    },
    setKusokFormObject:(context,reqData)=>{
      context.commit("SET_KUSOK_FORM_OBJECT",reqData);
    },
    setLoginedUser(context){
      //alert("it shoild be call the state");
      context.commit("SET_LOGINED_USER");  
    },
    logoutSystem(context){
      context.commit("LOG_OUT_SYSTEM");
    },

    // ---------- Notifications ----------
    //
    // Fetch the freshest page (newest-first). Returns the JSON list so
    // the bell can pop a toast on truly-new items without re-querying.
    async fetchNotifications({ commit }, opts = {}) {
      const headers = getHeader()
      if (!headers) return []
      const limit = opts.limit || 20
      try {
        const res = await axios.get(`${apiDomain}/api/notifications?limit=${limit}`, { headers })
        const list = Array.isArray(res.data) ? res.data : []
        commit('SET_NOTIFICATIONS', list)
        return list
      } catch (e) { return [] }
    },
    async fetchMoreNotifications({ state, commit }) {
      const headers = getHeader()
      if (!headers) return []
      const cursor = state.notifications.length
        ? state.notifications[state.notifications.length - 1].id
        : 0
      try {
        const res = await axios.get(
          `${apiDomain}/api/notifications?limit=20&cursor=${cursor}`, { headers }
        )
        const list = Array.isArray(res.data) ? res.data : []
        commit('APPEND_NOTIFICATIONS', list)
        return list
      } catch (e) { return [] }
    },
    async fetchUnreadCount({ commit }) {
      const headers = getHeader()
      if (!headers) return
      try {
        const res = await axios.get(`${apiDomain}/api/notifications/unread-count`, { headers })
        commit('SET_NOTIFICATIONS_UNREAD', (res.data && res.data.unread) || 0)
      } catch (e) { /* keep last value */ }
    },
    async markNotificationRead({ commit }, id) {
      // Optimistic: flip the local row first so the badge feels snappy.
      // Re-sync on failure isn't necessary — the next poll cycle will
      // pull the canonical state.
      commit('MARK_NOTIFICATION_READ', id)
      const headers = getHeader()
      if (!headers) return
      try { await axios.post(`${apiDomain}/api/notifications/${id}/read`, {}, { headers }) }
      catch (e) { /* swallow — next poll will reconcile */ }
    },
    async markAllNotificationsRead({ commit }) {
      commit('MARK_ALL_NOTIFICATIONS_READ')
      const headers = getHeader()
      if (!headers) return
      try { await axios.post(`${apiDomain}/api/notifications/read-all`, {}, { headers }) }
      catch (e) { /* next poll reconciles */ }
    },
    // Poll the cheap unread-count endpoint every 30s. When the count
    // grows since the last poll, hydrate the full list so the
    // dropdown / toast has the new items.
    startNotificationsPolling({ state, commit, dispatch }) {
      if (state.notificationsPollerId) return // already running
      const tick = async () => {
        const prev = state.notificationsUnread
        await dispatch('fetchUnreadCount')
        if (state.notificationsUnread > prev) {
          await dispatch('fetchNotifications')
        }
      }
      // Run once immediately so the bell isn't blank on first paint.
      tick()
      const id = setInterval(tick, 30000)
      commit('SET_NOTIFICATIONS_POLLER_ID', id)
    },
    stopNotificationsPolling({ state, commit }) {
      if (state.notificationsPollerId) {
        clearInterval(state.notificationsPollerId)
        commit('SET_NOTIFICATIONS_POLLER_ID', null)
      }
    },
  }
});